import { render, staticRenderFns } from "./pbi-dealer-group.page.vue?vue&type=template&id=a85ff8da"
import script from "./pbi-dealer-group.page.vue?vue&type=script&lang=ts"
export * from "./pbi-dealer-group.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports